import React, { useRef, useState, useEffect } from "react";
import {
  I2cInput,  I2cCheckboxGroup, I2cListItem,
  I2cCheckbox, I2cRadioGroup, I2cRadioButton,I2cDataTable
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { cardServiceOption ,myAccountFeature} from "./stringUtils";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import {DetailCellRenderer, InputRenderer, CheckboxRenderer } from "./CellRenderer";


const AccountsAndCardServices = ({ control, handleValueChanges, methods, errors, appSelectionForProgram, isFormDataUpdated }) => {
  const [rowDataInitial, setRowDataInitial] = useState(myAccountFeature || []);
  const [gridOptions, setGridOptions] = useState({});
  const table = useRef();
  const gridApiRef = useRef();
  const detailColumnDefs= []
  useEffect(() => {
    const backendData = methods.getValues('card_management_feature_my_account_features');
    if (backendData?.length > 0) {
      setGridOptions({
        columnDefs: [
          { headerName: '', field: '', },
          { headerName: 'Feature', field: 'feature', cellRenderer: CheckboxRenderer },
          { headerName: 'Custom Name', field: 'alternativeMethod', cellRenderer: InputRenderer }
        ],
        rowSelection: 'single',
        rowData: backendData,
        suppressRowClickSelection: false,
        masterDetail: true,
        isRowMaster: () => true,
        detailRowAutoHeight: true,
        gridBorder: true,
        detailCellRenderer: DetailCellRenderer,
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: detailColumnDefs,
            defaultColDef: {
              flex: 1,
            },
          },
          refreshStrategy: "rows",
          getDetailRowData: (params) => {
            params.successCallback(params.data);
          },
        },
        onCellClicked: (params) => {
          const node = params.node;
          if (node.master) {
            node.setExpanded(!node.expanded);
          }
        },
        onGridReady: (params) => {
          gridApiRef.current = params.api;
        },
        context: { methods, handleValueChanges }
      });
    } else {
      setGridOptions({
        columnDefs: [
          { headerName: 'Feature', field: 'feature', cellRenderer: CheckboxRenderer },
          { headerName: 'Custom Menu Name', field: 'alternativeMethod', cellRenderer: InputRenderer }
        ],
        rowSelection: 'single',
        rowData: myAccountFeature,
        suppressRowClickSelection: false,
        masterDetail: true,
        isRowMaster: () => true,
        detailRowAutoHeight: true,
        gridBorder: true,
        detailCellRenderer: DetailCellRenderer,
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: detailColumnDefs,
            defaultColDef: {
              flex: 1,
            },
          },
          refreshStrategy: "rows",
          getDetailRowData: (params) => {
            params.successCallback(params.data);
          },
        },
        onCellClicked: (params) => {
          const node = params.node;
          if (node.master) {
            node.setExpanded(!node.expanded);
          }
        },
        onGridReady: (params) => {
          gridApiRef.current = params.api;
        },
        context: { methods, handleValueChanges }
      });
    }
    const api = table?.current?.getGridApi();
    if (api) {
      api.setRowData && api.setRowData(backendData?.length > 0 ? backendData : rowDataInitial);
    }
  }, [isFormDataUpdated, methods.watch('card_management_feature_my_account_features')]);

  const handleCheckboxChange = (event, fieldName) => {
    const SelectedNetworkValue = event;
    let updatedSelectedNetworks = [
      ...(methods.getValues(fieldName) ?? []),
    ];
    if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== SelectedNetworkValue,
      );
    } else {
      updatedSelectedNetworks.push(SelectedNetworkValue);
    }
    methods.setValue(fieldName, updatedSelectedNetworks);
    methods.trigger();
    handleValueChanges();
  };
  return (
    <>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                My Accounts
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_my_account_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable it on the application."
                  {...field}
                  name="card_management_feature_my_account_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_my_account_feature_required_for_custom","")
                      methods.setValue("card_management_feature_my_account_feature_required_for",[]) 
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_my_account_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_my_account_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_my_account_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_my_account_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_my_account_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_my_account_feature_required_for_custom"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Enter Custom Name"
                        placeholder="Leave blank for default name"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"card_management_feature_my_account_feature_required_for_custom"}

                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_my_account_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_my_account_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_my_account_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_my_account_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_my_account_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_my_account_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_my_account_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_my_account_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
              {/* <div i2c-grid="12" className="custom-label">
                If yes, please specify the features you would like to enable.
              </div>
              <div i2c-grid="12">
                <Controller
                  name="card_management_feature_my_account_features"
                  control={control}
                  render={({ field }) => (
                    <I2cDataTable
                      id="dataTable1"
                      ref={table}
                      gridOptionInput={gridOptions}
                      notFound={[
                        {
                          description:
                            'No data available. Please add some features or refresh the page.',
                          type: 'noData',
                          icon: 'outline-info-circle',
                          primaryBtn: `<i2c-button variant="primary" size='large'>Reload</i2c-button>`,
                        },
                      ]}
                    ></I2cDataTable>
                  )}
                />
              </div> */}
            </>
          )
        }
      </div>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Card Services
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_card_services_feature_app_enable"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you would like to enable it on the application."
                  {...field}
                  name="card_management_feature_card_services_feature_app_enable"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_card_services_feature_app_enable_custom","")
                      methods.setValue("card_management_feature_card_services_feature_required_for",[]) 
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_card_services_feature_app_enable") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_card_services_feature_app_enable &&
                  methods.formState.touchedFields.card_management_feature_card_services_feature_app_enable
                  ? true
                  : false
              }
              message={errors.card_management_feature_card_services_feature_app_enable?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_card_services_feature_app_enable") === "Yes" && (
            <>
              <div i2c-grid="6@md">
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_card_services_feature_app_enable_custom"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        label="Enter Custom Name"
                        placeholder="Leave blank for default name"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"card_management_feature_card_services_feature_app_enable_custom"}

                      >
                      </I2cInput>
                    )}
                  />
                </div>
              </div>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  This feature is required for:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_card_services_feature_required_for"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="6@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_card_services_feature_required_for")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_card_services_feature_required_for");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_card_services_feature_required_for"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_card_services_feature_required_for")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_card_services_feature_required_for &&
                              methods.formState.touchedFields.card_management_feature_card_services_feature_required_for
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_card_services_feature_required_for?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
            </>
          )
        }
      </div>
      <div i2c-grid="grid gap-md" className="section-space">
        <div i2c-grid="12">
          <div className="sub-heading">
            <span className="productIconFlex">
              <span slot="label" className="organize-tooltip">
                Secure Card Activation
              </span>
              <AppSelectionIcons
                appSelectionForProgram={appSelectionForProgram}
                mobileLink="https://example.com/mobile-app-a"
                webLink="https://example.com/web-app-a"
              />
            </span>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="single-field-wrapper">
            <Controller
              name="card_management_feature_card_services_card_activation_after_login"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  label="Please confirm if you require cardholder to activate their card after they have logged into the app i.e. secure card activation."
                  {...field}
                  name=" card_management_feature_card_services_card_activation_after_login"
                  onI2cChange={(e) => {
                    field.onChange(e);
                    if(e.target.value === "No"){
                      methods.setValue("card_management_feature_card_services_info_for_validation",[]) 
                    }
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No"].map((bc, index) => (
                    <I2cRadioButton
                      key={index}
                      checked={
                        methods.watch("card_management_feature_card_services_card_activation_after_login") === bc
                      }
                      value={bc}
                    >
                      {bc}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.card_management_feature_card_services_card_activation_after_login &&
                  methods.formState.touchedFields.card_management_feature_card_services_card_activation_after_login
                  ? true
                  : false
              }
              message={errors.card_management_feature_card_services_card_activation_after_login?.message ?? "Invalid input"}
            />
          </div>
        </div>
        {
          methods.watch("card_management_feature_card_services_card_activation_after_login") === "Yes" && (
            <>
              <div i2c-grid="12">
                <div className="custom-label mb-8">
                  Please specify the information a cardholder must provide for validation for card activation:
                </div>
                <div className="single-field-wrapper">
                  <Controller
                    name="card_management_feature_card_services_info_for_validation"
                    control={control}
                    render={({ field }) => (
                      <>
                        <I2cCheckboxGroup
                          {...field}
                          className="centeredCheckbox checkbox-margin"
                        >
                          <div i2c-grid="grid gap-sm">
                            {cardServiceOption.map((card, index) => (
                              <I2cListItem
                                key={index}
                                i2c-grid="4@md"
                                variant="receipt"
                                label={card}
                                sublabel=""
                                value=""
                                type="checkbox"
                                checked={methods
                                  .watch("card_management_feature_card_services_info_for_validation")
                                  .includes(card)}
                                onI2cCheckboxClicked={(e) => {
                                  handleCheckboxChange(card, "card_management_feature_card_services_info_for_validation");
                                }}
                              >

                                <I2cCheckbox
                                  slot="prefix"
                                  name="card_management_feature_card_services_info_for_validation"
                                  filled
                                  value={card}
                                  label=""
                                  ignoreTab
                                  checked={methods
                                    .watch("card_management_feature_card_services_info_for_validation")
                                    .includes(card)}
                                  className="customCheckbox"
                                ></I2cCheckbox>
                              </I2cListItem>
                            ))}
                          </div>
                        </I2cCheckboxGroup>
                        <ErrorMessage
                          show={
                            errors.card_management_feature_card_services_info_for_validation &&
                              methods.formState.touchedFields.card_management_feature_card_services_info_for_validation
                              ? true
                              : false
                          }
                          message={
                            errors.card_management_feature_card_services_info_for_validation?.message ?? "Invalid input"
                          }
                        />
                      </>
                    )}
                  />
                </div>
              </div>
            </>
          )
        }

      </div>
    </>
  );
};

export default AccountsAndCardServices;
